import React from 'react';
import { MultiCombobox } from '~/components/uie-fix/MultiCombobox';
import { queryParameterContext, useStaticProps } from '../../context';

export function CountryFilter() {
  const { setValue, value } = queryParameterContext.useFilterField('country', 'PrimaryFilter');
  const { referenceData } = useStaticProps();

  const countries = React.useMemo(
    () =>
      Object.entries(referenceData.countries)
        .map(([code, country]) => ({ label: country.countryLabel, value: code }))
        .sort((a, b) => a.label.localeCompare(b.label)),
    [referenceData.countries]
  );

  return (
    <MultiCombobox
      value={value}
      aria-label="Country"
      placeholder="Country"
      onChange={(selectedItems) => setValue(selectedItems.filter((s) => !!s.trim()))}
      placeholderVariant="indicator"
    >
      {countries.map((country) => (
        <MultiCombobox.Option label={country.label} value={country.value} key={country.value} />
      ))}
    </MultiCombobox>
  );
}
